module.exports = __webpack_public_path__ + "static/media/vegitables_6.abddb0e5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_6.csv
// module id = 646
// module chunks = 0